import { render } from "./educationTurn.vue?vue&type=template&id=45e026a2"
import script from "./educationTurn.vue?vue&type=script&lang=js"
export * from "./educationTurn.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/hw-employment-front-end-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__